import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Row, Col } from 'react-bootstrap';
import AddStudentsForm from '../groups/AddStudentsForm';
import * as courseActions from '../../actions/coursesActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
// import label from '../../utils/lngEn';

class AddStudentsModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      name: {
        value: '',
        style: null,
        message: ''
      },
      course: {
        title: '',
        courseId: '',
        initialValues: {}
      }
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.getStudents = this.getStudents.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ class: nextProps.initial });
  }

  handleSubmit(values) {
    const { id: courseId } = this.props.course;
    this.props.courseActions.addStudentsToCourse(courseId, values.students).then(() => {
      this.props.update()
      this.props.closeModal();
    });
  }

  getStudents = () => {
    let newStudents = Object.assign([], this.props.students);
    let studentsOjbs = [];
    this.props.assignments.map(assignment => {
      newStudents.map((s, index) => {
        if (s.id == assignment.student) {
          delete newStudents[index];
        }
      });
    });
    newStudents.map(student => {
      studentsOjbs.push({
        id: student.id,
        email: student.user.email
      });
    });
    return studentsOjbs;
  };

  render() {
    return (
      <Modal show={this.props.showModal} onHide={this.props.closeModal} backdrop="static" className="addConflictModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                Add Students to Class
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Select Students to place into this class:</p>
          <AddStudentsForm
            onSubmit={this.handleSubmit}
            onCancel={this.props.onCancel}
            studentsArray={this.getStudents()}
            description="You may add more than one student at a time."
          />
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    assignments: state.assignments,
    students: state.students,
    student: state.student, //delete
    course: state.course
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddStudentsModal);



// WEBPACK FOOTER //
// ./src/components/classes/AddStudentsModal.js